export enum CertificationProviderStatusEnum {
    Active = 0,
    Archived = 1,
}
